import apiService from 'services/api.service'
import store from 'store'

export default {

    async getFilters() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'postpone/getFiltersForFilter',
                method: 'get',
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty filters!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

    async getPostponedClaims(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'postpone/getClaims',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty claims!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },
    async restoreClaim(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'postpone/restoreClaim',
                method: 'post',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('claim hasn\'t been restored!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },
}
